import { atom, useRecoilValue } from 'recoil';

export interface MetadataType {
  code: string;
  domain: string;
  subDomain: string;
  description: {
    [key in 'ko' | 'en' | 'fr' | 'es' | 'ru']: string;
  };
}

export const metadataState = atom<MetadataType[]>({
  key: 'metadataState',
  default: [],
});

export type Metadata2 = Record<string, Record<string, Record<string, string> & Record<'codeList', string[]>>>;
export const metadata2State = atom<Metadata2>({
  key: 'metadata2State',
  default: {},
});

/**
 * 서브 도메인의 메타데이터를 가져옵니다.
 */
export const useMetadata = (subDomain: string) => {
  return useRecoilValue(metadataState).filter(v => v.subDomain === subDomain);
};

/**
 * metadata2State 의 메타데이터를 가져옵니다.
 */
export const useMetadata2 = (domain: string, subDomain: string) => {
  return useRecoilValue(metadata2State)[domain]?.[subDomain];
};
